import { Common } from './common';
import { StandardMedication, CreateValues } from './models/standardMedication';

interface BulkUpsertResponse {
  attempts: number;
  errors: string[];
}

export class API {
  common: Common;

  constructor(common: Common) {
    this.common = common;
  }

  async findSuggestions(
    partialDisplayName: string,
  ): Promise<StandardMedication[]> {
    const url = this.common.constructPath(
      '/patient-previsit/standard-medications/',
      {
        partialDisplayName,
      },
    );

    return await this.common.getJSON(url);
  }

  async bulkUpsert(medications: CreateValues[]): Promise<BulkUpsertResponse> {
    const url = this.common.constructPath(`/standard-medications/`);
    return this.common.putJSON(url, {
      medications,
    });
  }
}
